export default "assets/images/texture-degrade-9f1e4d6f.jpg";